import { createIcon } from '@chakra-ui/react';

export const MbeEdit = createIcon({
  displayName: 'MbeEdit',
  viewBox: '0 0 64 64',
  path: (
    <g fill="none" fillRule="evenodd">
      <path
        d="m14.707 41.072 6.957 6.988 23.63-23.708-6.96-6.988-23.627 23.708zm6.957 10.36c-.372 0-.728-.148-.99-.411l-8.926-8.966a1.394 1.394 0 0 1 0-1.967l25.595-25.685a1.398 1.398 0 0 1 1.98 0l8.931 8.966a1.394 1.394 0 0 1 0 1.968l-25.6 25.684c-.263.263-.619.41-.99.41z"
        fill="#E2001A"
      />
      <path
        d="m13.488 43.98-1.573 7.096 6.953-1.692-5.38-5.404zM11.406 54c-.619 0-1.218-.24-1.676-.687a2.406 2.406 0 0 1-.672-2.252l2.256-10.175a1.394 1.394 0 0 1 2.352-.682l8.928 8.966c.355.357.49.877.354 1.362a1.397 1.397 0 0 1-1.014.977l-9.953 2.422c-.19.047-.384.069-.575.069zM40.301 15.383l6.962 6.99 3.461-3.476c.648-.65.648-1.71 0-2.362l-3.983-3.998a2.523 2.523 0 0 0-1.797-.748h-.003c-.681 0-1.323.267-1.806.75l-2.834 2.844zm6.962 10.361c-.371 0-.727-.148-.99-.412l-8.93-8.965a1.392 1.392 0 0 1 0-1.967l3.815-3.83A5.312 5.312 0 0 1 44.94 9h.005c1.428 0 2.768.559 3.774 1.57l3.983 3.998h.001a4.473 4.473 0 0 1 0 6.297l-4.452 4.467a1.393 1.393 0 0 1-.989.412z"
        fill="#939598"
      />
    </g>
  ),
});
